"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("../customConfig/api");
const request_1 = __importDefault(require("@hotmart/request"));
const DEFAULT_FOLDER_CODE = 'default-folder';
const ELEMENT_PER_PAGE = 100;
class FolderService {
    async getItemsFromMainFolder({ page, elementPerPage }) {
        return (0, request_1.default)('hotmartPlayerBackoffice.defaultFolderItems', {
            page,
            elementPerPage
        });
    }
    async getItemsFromFolderByCode({ folderData, page, elementPerPage }) {
        return (folderData === null || folderData === void 0 ? void 0 : folderData.isDefaultFolder)
            ? (0, request_1.default)('hotmartPlayerBackoffice.defaultFolderMediaItems', {
                page,
                elementPerPage
            })
            : (0, request_1.default)('hotmartPlayerBackoffice.itemsFromfolderCode', {
                folderCode: folderData === null || folderData === void 0 ? void 0 : folderData.code,
                page,
                elementPerPage
            });
    }
    parseApiResponseContent(content) {
        return content.map(({ data, ...rest }) => {
            var _a, _b;
            return ({
                ...data,
                ...rest,
                belongsToFolder: {
                    ...rest.belongs_to_folder,
                    category: 'folder',
                    isDefaultFolder: (_b = (_a = rest.belongs_to_folder) === null || _a === void 0 ? void 0 : _a.default_folder) !== null && _b !== void 0 ? _b : true
                }
            });
        });
    }
    async getFolderByCode({ folderData, page = 0, elementPerPage = ELEMENT_PER_PAGE }) {
        const { content, folder, ...rest } = await ((folderData === null || folderData === void 0 ? void 0 : folderData.code)
            ? this.getItemsFromFolderByCode({ folderData, page, elementPerPage })
            : this.getItemsFromMainFolder({ page, elementPerPage }));
        const parsedContent = this.parseApiResponseContent(content);
        if (!(folderData === null || folderData === void 0 ? void 0 : folderData.code) && page === 0) {
            const defaultFolder = {
                code: DEFAULT_FOLDER_CODE,
                category: 'folder',
                isDefaultFolder: true
            };
            parsedContent.unshift(defaultFolder);
        }
        return {
            content: parsedContent,
            folder,
            ...rest
        };
    }
    async searchItems(name, { elementPerPage = ELEMENT_PER_PAGE, page = 0 }) {
        const { content, totalPages, totalElements, ...rest } = await (0, request_1.default)('hotmartPlayerBackoffice.search', {
            name,
            category: 'media',
            elementPerPage,
            page
        });
        const calculateTotalPages = totalPages
            ? totalPages
            : Math.ceil(totalElements / elementPerPage);
        const mediasFromSearch = this.parseApiResponseContent(content);
        return {
            content: mediasFromSearch,
            totalElements,
            totalPages: calculateTotalPages,
            ...rest
        };
    }
}
exports.default = new FolderService();
